module.exports = __webpack_public_path__ + "assets/333600724df2d95c5b19c0703ec62d1b.png";